/* eslint-disable camelcase */
/* eslint-disable no-undef */
import React, { useState } from 'react';
import {
  Grid, AppBar, Toolbar,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import BusinessIcon from '@material-ui/icons/Business';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PropTypes from 'prop-types';
import MeltedCheese from '../../assets/images/MeltyCheese.svg';
import { getUserData } from '../../utility/common';
import useStyles from '../style';

function HeaderComponent(props) {
  const { history, deploymentDetails } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const userData = getUserData();
  const {
    givenname, surname, dn, applicationStoreRoles,
  } = userData;

  const storeRoles = applicationStoreRoles && Array.isArray(applicationStoreRoles) ? applicationStoreRoles : [applicationStoreRoles];
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    history.push('/logout');
  };

  const title = `${givenname} ${surname}`;

  const handleDrawerToggle = () => {
    props.handleDrawerToggle();
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Grid item sm={12} xs={12}>
        <AppBar position="fixed" className={classes.headerStyle}>
          <Toolbar className="toolbar">
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              edge="end"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <div className="width-100-per">
              <Avatar title={title} onClick={handleClick} className="avatar">
                {givenname ? givenname.charAt(0).toUpperCase() : ''}
                {surname ? surname.charAt(0).toUpperCase() : ''}
              </Avatar>
              <Menu
                id="fade-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
                className="avatar-menu"
              >
                <MenuItem title="Username">
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  {' '}
                  <ListItemText primary={dn} />
                </MenuItem>
                {applicationStoreRoles && (
                  <MenuItem title="PDW Role">
                    <ListItemIcon>
                      <BusinessIcon />
                    </ListItemIcon>
                    <List className={classes.avatarRole}>
                      {storeRoles.map((value) => (
                        <ListItem key={value} role={undefined} dense button className="avatar-role-li">
                          <ListItemText primary={value} />
                        </ListItem>
                      ))}
                    </List>
                  </MenuItem>
                )}
                <MenuItem onClick={() => handleLogout()} title="Logout">
                  <ListItemIcon>
                    <ExitToAppIcon />
                  </ListItemIcon>
                  {' '}
                  <ListItemText primary="Logout" />
                </MenuItem>
              </Menu>
            </div>
            {(deploymentDetails?.is_deployment_running && deploymentDetails.is_deployment_running === "true") &&
              <Grid sm={12} xs={12} className="deployment-message">
                <div>
                  {deploymentDetails?.message ? deploymentDetails?.message : ""}
                </div>
              </Grid>}
          </Toolbar>
        </AppBar>
      </Grid>

      <Grid item sm={12} xs={12} className="melted-icon">
        <CardMedia
          component="svg"
          alt="Melted Cheese"
          height="4px"
          image={MeltedCheese}
          title="Melted Cheese"
          className={classes.svgStyles}
        />
      </Grid>
    </div>
  );
}

HeaderComponent.propTypes = {
  handleDrawerToggle: PropTypes.func.isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default HeaderComponent;
